import { authPost } from "@api";

interface SubscriptionSignupBody {
  deployment_id: string;
  price_id: string;
  quantity: number;
}

interface SubscriptionSignupResponse {
  subscription_id: string;
  client_secret: string;
}

export const subscriptionSignup = (
  deploymentId: string,
  priceId: string,
  qty: number
) => {
  const url = `/api/payments/subscriptions`;
  return authPost<SubscriptionSignupBody, SubscriptionSignupResponse>(url, {
    deployment_id: deploymentId,
    price_id: priceId,
    quantity: qty,
  });
};
